import { Box, Button, Dialog, DialogTitle } from '@mui/material'
import { Trans } from 'react-i18next'

interface InstallerLevelDialogProps {
    open: boolean
    closeFunc: () => void
}

export default function InstallerLevelDialog(props: InstallerLevelDialogProps) {
  return (
        <Dialog open={props.open}>
            <Box>
                <DialogTitle sx={{ backgroundColor: 'blue' }}><Trans>Installer Level Settings</Trans></DialogTitle>
                {/* Instruction picture for customers */}
                <Box sx={{ p: 2 }}>
                    <Trans>Installer level required. Enable installer level from “Settings → Installer level → Allow installer level settings”</Trans>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'center', pb: 2 }}>
                    <Button color="primary" onClick={props.closeFunc}><Trans>OK</Trans></Button>
                </Box>
            </Box>
        </Dialog>
  )
}
